//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum TourType {
	AccessibleWheelchair = 65,
	Bike = 66,
	Driving = 67,
	DeafMute = 68,
	SegwayOrEScooter = 69,
	HorsebackRiding = 72,
	Indoor = 73,
	Motorcycling = 77,
	Boat = 79,
	Running = 82,
	CrossCountrySkiing = 83,
	Train = 84,
	Bus = 85,
	AllTerrainVehicles = 86,
	Walk = 87
}
